module.exports = __webpack_public_path__ + "static/media/dm.160e8234.jpg";